import styled from 'styled-components';

export const CardContainer = styled.div`
  min-height: 200px;
  display: flex;
  flex-direction: column;
  background-color: ${({ bgColor }) => bgColor || '#ffffff'};
  border-radius: 8px;

  @media screen and (max-width: 1000px) {
    min-height: 200px;
  }

  @media screen and (max-width: 768px) {
    min-height: 200px;
  }
`;